import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.57859 4.29566L5.72995 4.30289C6.68971 4.37025 7.5723 4.8428 8.14864 5.5979C8.33149 5.83746 8.28155 6.17691 8.03711 6.3561C7.79267 6.53528 7.44629 6.48635 7.26344 6.2468C6.87921 5.7434 6.29082 5.42836 5.65098 5.38345C5.0538 5.34154 4.46675 5.53879 4.02236 5.92682L3.92936 6.01287L2.27793 7.63115C1.44007 8.48131 1.45205 9.83267 2.30486 10.6684C3.12827 11.4754 4.44214 11.5141 5.30643 10.7827L5.39727 10.7014L6.34242 9.77517C6.55827 9.56363 6.90824 9.56363 7.12409 9.77517C7.32333 9.97043 7.33866 10.2777 7.17007 10.4902L7.12409 10.5412L6.17208 11.474C4.87083 12.7057 2.80241 12.6881 1.5232 11.4345C0.27764 10.2138 0.227822 8.25993 1.39244 6.97456L1.48953 6.87183L3.14762 5.2469C3.79209 4.6151 4.67172 4.27268 5.57859 4.29566ZM11.678 1.49358C12.9236 2.71422 12.9734 4.6681 11.8088 5.95347L11.7117 6.0562L10.0536 7.68113C9.37331 8.34803 8.43102 8.69251 7.47126 8.62515C6.5115 8.55779 5.62891 8.08523 5.05256 7.33013C4.86972 7.09058 4.91965 6.75112 5.16409 6.57194C5.40853 6.39275 5.75492 6.44168 5.93776 6.68124C6.32199 7.18464 6.91038 7.49967 7.55022 7.54458C8.14741 7.5865 8.73445 7.38924 9.17885 7.00122L9.27184 6.91517L10.9233 5.29688C11.7611 4.44673 11.7492 3.09536 10.8963 2.25961C10.0729 1.45267 8.75906 1.4139 7.89375 2.14631L7.80279 2.22773L6.85211 3.15398C6.63563 3.3649 6.28567 3.3639 6.07045 3.15175C5.87179 2.95592 5.85737 2.64862 6.0266 2.43662L6.07273 2.38572L7.02912 1.45399C8.33038 0.222326 10.3988 0.239941 11.678 1.49358Z"
        fill="white"
      />
    </Svg>
  );
};

export default Icon;
